var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _vm.inPreview
        ? _c(
            "div",
            [
              _vm.pdfUrl
                ? _c(
                    "a",
                    { attrs: { href: _vm.pdfUrl, target: "_blank" } },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "text-primary underline d-inline-block mr-2",
                          attrs: { "data-cy": "document-viewer" }
                        },
                        [
                          _vm._v(" * Visualizando documento "),
                          _c("small", [
                            _vm._v("(Formulario de Compras Adquisiciones)")
                          ]),
                          _vm._v(" * ")
                        ]
                      ),
                      _c("feather-icon", {
                        attrs: { icon: "ExternalLinkIcon" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("pdf-preview-complete", {
                attrs: {
                  inPreview: _vm.inPreview,
                  generatingPreview: _vm.generatingPreview,
                  saving: _vm.saving,
                  pdfUrl: _vm.pdfUrl,
                  backToForm: _vm.backToForm,
                  save: _vm.save
                },
                on: {
                  "in-preview": function($event) {
                    _vm.inPreview = $event
                  }
                }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "form",
                {
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("h2", [_vm._v("FORMULARIO DE COMPRAS ADQUISICIONES")]),
                  _c("div", { staticClass: "row mt-10" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "label",
                              { attrs: { for: "previousDocument" } },
                              [_vm._v(" ¿Deseas basarte en otro documento? ")]
                            ),
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  options: _vm.createdDocuments,
                                  name: "previousDocument",
                                  label: "label",
                                  "data-cy": "created-document-data",
                                  clearable: true
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.getDocumentData($event)
                                  }
                                },
                                model: {
                                  value: _vm.previousDocument,
                                  callback: function($$v) {
                                    _vm.previousDocument = $$v
                                  },
                                  expression: "previousDocument"
                                }
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _vm._v(" no hay documentos registrados ")
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      !_vm.attachments || !_vm.attachments.length
                        ? _c(
                            "div",
                            { staticClass: "col-12 mb-4" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permission",
                                      rawName: "v-has-permission",
                                      value: "ED060",
                                      expression: "'ED060'"
                                    },
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal",
                                      value: "add-repository-file",
                                      expression: "'add-repository-file'"
                                    }
                                  ],
                                  staticClass: "btn-icon mt-1 w-100",
                                  attrs: {
                                    variant: "secondary",
                                    "data-cy": "from-repository",
                                    disabled: _vm.attachments.length >= 1
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "ServerIcon" }
                                  }),
                                  _vm._v(
                                    " Seleccionar FISABS desde el repositorio "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.attachments, function(file) {
                        return file.name && file.name.includes("FISABS")
                          ? _c("div", { key: file.id, staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "row align-items-center" },
                                [
                                  _c("vs-icon", {
                                    staticClass: "col-2",
                                    attrs: {
                                      icon: "description",
                                      size: "25px",
                                      color: "primary"
                                    }
                                  }),
                                  _c(
                                    "b",
                                    { staticClass: "w-100 text-center col-8" },
                                    [_vm._v(_vm._s(file.name))]
                                  ),
                                  _c("vs-button", {
                                    staticClass: "col-2",
                                    attrs: {
                                      color: "danger",
                                      type: "flat",
                                      icon: "clear"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRepositoryFile(file.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      }),
                      !_vm.attachments || !_vm.attachments.length
                        ? _c("div", { staticClass: "col-12" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "danger span-text-validation-danger v-enter-to"
                              },
                              [
                                _c("small", [
                                  _vm._v(
                                    " Debes seleccionar un archivo desde el repositorio "
                                  )
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.attachments && _vm.attachments.length && !_vm.loading
                    ? _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [_c("vs-divider")],
                            1
                          ),
                          _c("div", { staticClass: "col-12 mt-5" }, [
                            _c("h4", [_vm._v("SERVICIOS O PRODUCTOS")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _vm._l(_vm.formData.items, function(item, index) {
                                return _c(
                                  "div",
                                  { key: item.id, staticClass: "row mt-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-1 d-flex align-items-center"
                                      },
                                      [
                                        item.selected === true
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "success",
                                                  size: "sm"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.unSelectItem(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" selec. ")]
                                            )
                                          : _vm._e(),
                                        item.selected === false
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "secondary",
                                                  size: "sm"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.selectItem(item)
                                                  }
                                                }
                                              },
                                              [_vm._v(" no selec. ")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-5" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            label: "Nombre de servicio",
                                            "data-cy": "name-service"
                                          },
                                          model: {
                                            value: item.requiredServiceName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "requiredServiceName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.requiredServiceName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-1" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100",
                                          attrs: {
                                            type: "number",
                                            label: "Cantidad",
                                            "data-cy": "quantity"
                                          },
                                          model: {
                                            value: item.serviceQuantity,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceQuantity",
                                                $$v
                                              )
                                            },
                                            expression: "item.serviceQuantity"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100 text-right",
                                          attrs: {
                                            type: "number",
                                            label: "Precio unitario",
                                            "data-cy": "unit-price"
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.changeReceivedQuantity(
                                                item
                                              )
                                            }
                                          },
                                          model: {
                                            value: item.serviceAmount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceAmount",
                                                $$v
                                              )
                                            },
                                            expression: "item.serviceAmount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("vs-input", {
                                          staticClass: "w-100 text-right",
                                          attrs: {
                                            type: "number",
                                            label: "Precio total",
                                            "data-cy": "total-price",
                                            disabled: ""
                                          },
                                          model: {
                                            value: item.serviceTotalAmount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                item,
                                                "serviceTotalAmount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.serviceTotalAmount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("vs-divider")
                                  ],
                                  1
                                )
                              }),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-9" }),
                                _c(
                                  "div",
                                  { staticClass: "col-3 text-right" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "outline-warning",
                                          size: "sm"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.addItem()
                                          }
                                        }
                                      },
                                      [_vm._v(" agregar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            2
                          ),
                          _c("vs-divider"),
                          _c("div", { staticClass: "col-6 mt-2" }),
                          _c("div", { staticClass: "col-6 mt-2" }, [
                            _c("div", { staticClass: "row" }, [
                              !_vm.formData.exemptSell
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(" Total Neto ")
                                  ])
                                : _vm._e(),
                              !_vm.formData.exemptSell
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.netAmount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.formData.exemptSell
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(" IVA (19%) ")
                                  ])
                                : _vm._e(),
                              !_vm.formData.exemptSell
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.taxAmount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(" Subtotal ")
                              ]),
                              _c("div", { staticClass: "col-6 mt-3" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("amount")(_vm.formData.subtotal)
                                    ) +
                                    " "
                                )
                              ]),
                              _vm.formData.exemptSell
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(" Monto Exento ")
                                  ])
                                : _vm._e(),
                              _vm.formData.exemptSell
                                ? _c("div", { staticClass: "col-6 mt-3" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("amount")(
                                            _vm.formData.exemptAmount
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "general-observations",
                                  label:
                                    "Observaciones generales de la solicitud"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-form-textarea", {
                                            attrs: {
                                              name: "general-observations",
                                              "data-vv-as":
                                                "observaciones generales de la solicitud",
                                              "data-cy": "general-observations",
                                              state: invalid,
                                              maxlength: 2000,
                                              placeholder:
                                                "Observaciones generales",
                                              rows: "3",
                                              "max-rows": "8"
                                            },
                                            model: {
                                              value:
                                                _vm.formData
                                                  .generalObservations,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "generalObservations",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.generalObservations"
                                            }
                                          }),
                                          _vm.formData.generalObservations
                                            ? _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "form-text text-muted text-right"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formData
                                                          .generalObservations
                                                          ? _vm.formData
                                                              .generalObservations
                                                              .length
                                                          : 0
                                                      ) +
                                                      " / 2000 "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1339427960
                                )
                              })
                            ],
                            1
                          ),
                          _c("vs-divider"),
                          _c("div", { staticClass: "col-12" }, [
                            _c("h4", [_vm._v("Documentos")])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              !_vm.grcAttachmentsSelectors.loading
                                ? _c("dynamic-file-selector", {
                                    attrs: {
                                      selectors: _vm.grcAttachmentsSelectors.list
                                        .slice()
                                        .sort(function(a, b) {
                                          return a.order - b.order
                                        })
                                        .map(function(sel) {
                                          return Object.assign(
                                            {},
                                            sel,
                                            sel.extra,
                                            { index: sel.order }
                                          )
                                        }),
                                      "object-to-evaluate": _vm.formData,
                                      files: _vm.dynamicSelectorFiles,
                                      "reset-key": _vm.dfsResetKey
                                    },
                                    on: {
                                      "update-files": _vm.updateFiles,
                                      valid: function(valid) {
                                        _vm.dynamicFileSelectorValid = valid
                                      }
                                    }
                                  })
                                : _c(
                                    "div",
                                    [
                                      _c("b-skeleton", {
                                        attrs: {
                                          animation: "fade",
                                          width: "100%"
                                        }
                                      }),
                                      _c("b-skeleton", {
                                        attrs: {
                                          animation: "fade",
                                          width: "100%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c("UploadFile", {
                                      attrs: {
                                        permission: "*",
                                        accept:
                                          "application/pdf, .doc, .docx, .xlsx, .ppt",
                                        text: "Seleccionar documentos",
                                        "upload-to": "ed",
                                        "button-class": {
                                          "btn-block": true,
                                          "mb-5": _vm.errors.has(
                                            "custom-document.fileName"
                                          )
                                        },
                                        "container-class": "w-100"
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.addOthersFile()
                                        }
                                      },
                                      model: {
                                        value: _vm.fileOthers,
                                        callback: function($$v) {
                                          _vm.fileOthers = $$v
                                        },
                                        expression: "fileOthers"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._l(_vm.formData.attachments, function(
                                  file
                                ) {
                                  return !file.name.includes("FISABS")
                                    ? _c(
                                        "div",
                                        { key: file.id, staticClass: "col-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column align-items-center"
                                            },
                                            [
                                              _c("vs-icon", {
                                                attrs: {
                                                  icon: "description",
                                                  size: "45px",
                                                  color: "primary"
                                                }
                                              }),
                                              _c(
                                                "b",
                                                {
                                                  staticClass:
                                                    "text-truncate w-100 text-center"
                                                },
                                                [_vm._v(_vm._s(file.name))]
                                              ),
                                              _c("vs-button", {
                                                attrs: {
                                                  color: "danger",
                                                  type: "flat",
                                                  icon: "clear"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeOthersFile(
                                                      file.id
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _c("div", { staticClass: "text-xs text-right" }, [
                _c("b", [
                  _vm._v("Los campos marcados con "),
                  _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
                  _vm._v(" son obligatorios")
                ])
              ]),
              _c("form-buttons", {
                attrs: {
                  saving: _vm.saving,
                  disabled: _vm.dfsSelectorsLoading,
                  back: function() {
                    return this$1.$router.back()
                  },
                  preview: _vm.preview,
                  save: _vm.save,
                  saveDraft: _vm.saveDraft
                }
              })
            ],
            1
          ),
      _c("repository-selector", {
        attrs: {
          "add-file": _vm.addRepositoryFile,
          files: _vm.attachments,
          "remove-file": _vm.removeRepositoryFile,
          "max-files": 100,
          "required-file-type": "FISABS",
          "required-approval-state": _vm.approvalStateTypes.ON_APROBATION
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }